import axios from "axios";
import { toast } from "react-toastify";
import { toastError } from "./utils";
let toastAlreadyShown = false;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const reqUrl = err.config.url;
    // can replace the checks with a in_array check

    if (err.response.status === 401) {
      if (reqUrl !== "/auth/login" && reqUrl !== "/organizations") {
        if (!toastAlreadyShown) {
          // show toast and disable errors for the next 10s
          toastAlreadyShown = true;
          toast.error(err.message, toastError);
          setTimeout(() => {
            toastAlreadyShown = false;
          }, 10000);
        }
      }
    }
    if (err.response.status === 500) {
      toast.error(err.message, toastError);
    }
  }
);
export default axiosInstance;
